const isDev = process.env.NODE_ENV === 'development';
const isServer = typeof window === 'undefined';

// --- Core log printer ---
function logToConsole(level, message, meta) {
  const timestamp = new Date().toISOString();
  const logEntry = { level, message, ...meta, timestamp };

  const colorMap = {
    debug: '\x1b[36m%s\x1b[0m', // cyan
    info: '\x1b[32m%s\x1b[0m', // green
    warn: '\x1b[33m%s\x1b[0m', // yellow
    error: '\x1b[31m%s\x1b[0m', // red
    fatal: '\x1b[41m%s\x1b[0m', // red background
  };
  // In development → readable, colorized
  if (isDev) {
    console.log(colorMap[level], `[${level.toUpperCase()}]`, message, meta || '');
  } else {
    console.log(colorMap[level], `[${level.toUpperCase()}]`, message, meta || '');

    // console.log('Something went wrong');
    // In production → structured JSON
    // console.log(JSON.stringify(logEntry));
  }
}

// --- Core handler ---
function handleError(level, message, err, meta) {
  const safeError = err instanceof Error ? err.message : String(err);
  logToConsole(level, message, { ...meta, error: safeError });

  if (level === 'error' || level === 'fatal') {
    try {
      // TODO : Integrate with Sentry or other logging service
    } catch (e) {
      if (isDev) console.warn('Sentry logging failed:', e);
    }
  }
}

// --- Exported API ---
export const logger = {
  debug: (msg, meta) => logToConsole('debug', msg, meta),
  info: (msg, meta) => logToConsole('info', msg, meta),
  warn: (msg, meta) => logToConsole('warn', msg, meta),
  error: (msg, err, meta) => handleError('error', msg, err, meta),
  fatal: (msg, err, meta) => handleError('fatal', msg, err, meta),
};
